(function () {
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function initTheme() {
    document.querySelectorAll('[data-quantity-minus]').forEach(function (button) {
      button.addEventListener('click', function () {
        var input = button.parentElement.querySelector('input[name="quantity"]');
        if (input) input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
    });

    document.querySelectorAll('[data-quantity-plus]').forEach(function (button) {
      button.addEventListener('click', function () {
        var input = button.parentElement.querySelector('input[name="quantity"]');
        if (input) input.value = Math.max(1, parseInt(input.value, 10) || 1) + 1;
      });
    });

    document.querySelectorAll('.product-page').forEach(function (section) {
      var mainImage = section.querySelector('#ProductMainImage');
      var thumbnails = Array.from(section.querySelectorAll('.thumbnail[data-image-url]'));

      thumbnails.forEach(function (button) {
        button.addEventListener('click', function () {
          if (!mainImage) return;
          var url = button.getAttribute('data-image-url');
          if (!url) return;
          mainImage.src = url;
          mainImage.removeAttribute('srcset');
          mainImage.alt = button.getAttribute('data-image-alt') || mainImage.alt;
          thumbnails.forEach(function (thumb) {
            var active = thumb === button;
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      });

      var jsonNode = section.querySelector('[data-product-json]');
      var form = section.querySelector('.product-form');
      if (!jsonNode || !form) return;

      var product;
      try { product = JSON.parse(jsonNode.textContent); } catch (error) { return; }
      var optionSelects = Array.from(form.querySelectorAll('[data-option-index]'));
      var variantInput = form.querySelector('[data-variant-id]');
      var priceNode = section.querySelector('[data-product-price]');
      var comparePriceNode = section.querySelector('[data-product-compare-price]');
      var addButton = form.querySelector('[data-add-to-cart]');
      var message = form.querySelector('[data-product-message]');
      var currency = section.getAttribute('data-currency') || 'EUR';

      function updateVariant() {
        var selectedValues = optionSelects.map(function (select) { return select.value; });
        var variant = (product.variants || []).find(function (item) {
          return (item.options || []).every(function (value, index) {
            return value === selectedValues[index];
          });
        });

        if (!variant) {
          if (variantInput) variantInput.value = '';
          if (addButton) {
            addButton.disabled = true;
            addButton.textContent = 'Combinaison indisponible';
          }
          if (message) message.textContent = 'Cette combinaison n’est pas disponible. Choisissez une autre option.';
          return;
        }

        if (variantInput) variantInput.value = variant.id;
        if (priceNode) priceNode.textContent = money(variant.price, currency);
        if (comparePriceNode) {
          if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
            comparePriceNode.textContent = money(variant.compare_at_price, currency);
            comparePriceNode.hidden = false;
          } else {
            comparePriceNode.textContent = '';
            comparePriceNode.hidden = true;
          }
        }
        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
        }
        if (message) message.textContent = variant.available ? '' : 'Cette variante est actuellement indisponible.';

        if (variant.featured_image && variant.featured_image.src && mainImage) {
          mainImage.src = variant.featured_image.src;
          thumbnails.forEach(function (thumb) {
            var active = thumb.getAttribute('data-image-url').split('?')[0] === variant.featured_image.src.split('?')[0];
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      optionSelects.forEach(function (select) { select.addEventListener('change', updateVariant); });

      // AJAX add-to-cart; native Shopify form remains the fallback if the request fails.
      form.addEventListener('submit', function (event) {
        if (!window.fetch || !variantInput || !variantInput.value) return;
        event.preventDefault();
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'Ajout en cours…';
        }
        if (message) message.textContent = '';
        var body = new FormData(form);
        fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: body
        }).then(function (response) {
          if (!response.ok) return response.json().then(function (data) { throw data; });
          return response.json();
        }).then(function () {
          return fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js', {
            headers: { 'Accept': 'application/json' }
          });
        }).then(function (response) { return response.json(); })
          .then(function (cart) {
            document.querySelectorAll('.cart-count').forEach(function (node) { node.textContent = cart.item_count; });
            if (message) message.textContent = 'Ajouté au panier.';
            if (addButton) {
              addButton.disabled = false;
              addButton.textContent = 'Ajouter au panier';
            }
          }).catch(function () {
            // Fall back to the native Shopify add-to-cart endpoint.
            form.removeEventListener('submit', arguments.callee);
            form.submit();
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTheme);
  } else {
    initTheme();
  }
})();